import React, { useState, Fragment } from "react";
import Form from "react-validation/build/form";
import Input from "react-validation/build/input";
import download from "downloadjs";
import crossimg from "../../assets/images/icons/cross.svg";
import BoLoader from "../../helpers/BoLoader";
import DialoguePopup from "../../helpers/DialoguePopup";
import adminDashboardService from "../../services/admindashboard.service";
import ExportToExcel from "../superadmin/ExportToExcel";
import SearchGridRejectedData from "../cardholders/SearchGridRejectedData";
import samplefile from "../../middlewareTemp/SampleViewCardBalance.csv";

const ViewCardBalance = () => {
  const [boloader, setBoLoader] = useState(false);
  const [results, setResults] = useState(null);
  const [summary, setSummary] = useState(null);

  const [fileName, setFileName] = useState("");
  const [fileSize, setFileSize] = useState("");
  const [isValidFile, setisValidFile] = useState(true);

  const [modalShow, setModalShow] = useState(false);
  const [modelhdng, setMdlHdng] = useState("");
  const [modelbdy, setMdlBdy] = useState("");
  const [MdlIcon, setMdlIcon] = useState("");

  const errorAndSuccessModl = (heading, body, errIcon) => {
    setModalShow(true);
    setMdlHdng(heading);
    setMdlBdy(body);
    setMdlIcon(errIcon);
  };

  const formatBytes = (bytes, decimals = 2) => {
    if (bytes === 0) return "0 Bytes";
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ["Bytes", "KB", "MB", "GB", "TB"];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
  };

  const downloadSample = () => {
    try {
      return download(samplefile);
    } catch (error) {}
  };

  const onCrossImg = () => {
    setFileName("");
    setFileSize("");
    setisValidFile(true);
  };

  const uploadFileClick = () => {
    document.getElementById("ViewCardBalanceFileUpload").click();
  };

  const onFileSelected = (e) => {
    const file_data = e.target.files[0];
    if (!file_data) return;

    let reg = /(.*?)\.(xlsx|xls)$/;
    if (!file_data.name.match(reg)) {
      setisValidFile(false);
      return;
    }
    setisValidFile(true);
    setFileName(file_data.name);
    setFileSize(formatBytes(file_data.size));
    setResults(null);
    setSummary(null);
    setBoLoader(true);

    const formdata = new FormData();
    formdata.append("excelFile", file_data);

    adminDashboardService
      .ViewCardBalance(formdata)
      .then((response) => {
        setBoLoader(false);
        const payload = response?.data?.payload;
        const rows = payload?.results;
        if (rows?.length > 0) {
          setResults(rows);
          setSummary(payload);
        } else {
          errorAndSuccessModl(
            "Error",
            payload?.message || "No balances were returned",
            "icon-error"
          );
        }
      })
      .catch((error) => {
        setBoLoader(false);
        const msgBody =
          error?.response?.data?.message || "Something Went Wrong";
        errorAndSuccessModl("Error", msgBody, "icon-error");
      })
      .finally(() => {
        // allow re-selecting the same file
        e.target.value = null;
      });
  };

  const handleOnSubmit = (e) => {
    e.preventDefault();
  };

  return (
    <Fragment>
      <BoLoader loading={boloader} />
      <DialoguePopup
        show={modalShow}
        onHide={() => setModalShow(false)}
        hideallpopups={() => setModalShow(false)}
        modelheading={modelhdng}
        modelbody={modelbdy}
        modelicon={MdlIcon}
      />

      <div className="row">
        <div className="col-md-12">
          <h3 className="mb-1">View Card Balance</h3>
          <p className="fs-12 clr-submarine mb-3">
            Upload an Excel file with <b>CardHashId</b> and{" "}
            <b>IssuerCategory</b> columns to read live balances from the issuer.
            Supported issuers: Issuer11, Issuer12, IssuerOB, OB-FIT, OB-TIX,
            OB-OF. This is a read only lookup - nothing is written to the issuer.
          </p>
        </div>
      </div>

      <Form className="search-form" onSubmit={handleOnSubmit}>
        <div className="row">
          <div className="col-md-12">
            <a
              onClick={downloadSample}
              style={{
                color: "blueviolet",
                font: "message-box",
                cursor: "pointer",
              }}
            >
              <b>Click Here to Download the Sample File.</b>
            </a>
          </div>
        </div>

        {fileName === "" ? (
          <div className="col-md-6 ps-0">
            <div className="form-group">
              <label>Attach Excel File</label>
              <div className="form-controls">
                <div>
                  <Input
                    type="file"
                    hidden
                    id="ViewCardBalanceFileUpload"
                    className="form-control"
                    accept=".xlsx,.xls"
                    name="excelFile"
                    onChange={onFileSelected}
                  />
                  <h5
                    className="form-control file-control"
                    onClick={uploadFileClick}
                  >
                    <label>Drag files here to upload or </label> Browse file
                  </h5>
                  {!isValidFile && (
                    <span className="help-block has_error">
                      Invalid file format
                    </span>
                  )}
                </div>
                <span className="icon-upload-file _ico">
                  <span className="path1"></span>
                  <span className="path2"></span>
                </span>
              </div>
              <span className="fs-12 clr-submarine mt-2 d-block">
                Supported file types XLSX/XLS. Large files may take several
                minutes - please keep this page open.
              </span>
            </div>
          </div>
        ) : (
          <div className="col-md-6 ps-0">
            <div className="form-group">
              <div className="bo-file d-flex">
                <div className="file-name">
                  <span className="icon-upload-file _ico">
                    <span className="path1"></span>
                    <span className="path2"></span>
                  </span>
                  <h5>
                    <span>{fileName}</span>
                  </h5>
                </div>
                <div className="ml-auto file-size" onClick={onCrossImg}>
                  <span>{fileSize}</span>
                  <img
                    className="cross-icon"
                    src={crossimg}
                    onClick={onCrossImg}
                    alt=""
                  />
                </div>
              </div>
            </div>
          </div>
        )}
      </Form>

      {results?.length > 0 && (
        <Fragment>
          {summary?.partial && (
            <div className="alert alert-warning fs-12" role="alert">
              <b>Partial result. </b>
              {summary?.message}
            </div>
          )}
          <div className="d-flex align-items-center mb-2">
            <span className="fs-12 clr-submarine">
              {summary?.processed} card(s) returned
              {summary?.failedCount > 0 &&
                " - " + summary?.failedCount + " failed or rejected"}
            </span>
            <div className="nav-item ms-auto" role="presentation">
              <ExportToExcel
                Dataset={results}
                Name="ViewCardBalance"
                calledfrom="viewcardbalance"
              />
            </div>
          </div>
          <SearchGridRejectedData
            methodname="viewcardbalance"
            placeholdervalue="Search"
            headersdata={["TOKEN ID", "AMOUNT"]}
            screenname="viewcardbalance"
            calledfrom="viewcardbalance"
            data={results}
          />
        </Fragment>
      )}
    </Fragment>
  );
};

export default ViewCardBalance;
